import { useContext, useEffect } from 'react';
import MenuContext from "../context";
import { observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {iconSpaceStyle} from "../style";

/**
 * @param {object} props
 * @param {object} [props.icon]
 */
function IconSpace({icon}) {
  const store = useContext(MenuContext);
  const classes = ['icon-space'];
  const show = !!icon || store.hasIcons;

  useEffect(() => {
    if(!icon)
      return;
    
    const _icon = store.registerIcon();
    return () => {
      _icon.destroy();
    }
  }, [icon]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!show) {
    return null;
  }

  return (
    <div className={classes.join(" ")}>
      {
        icon &&
        <FontAwesomeIcon
          icon={icon}
        />
      }
      <style jsx>{iconSpaceStyle}</style>
    </div>
  );
}

export default observer(IconSpace);